import { getLocaleFromPathname } from '@/shared/utils/i18n/locale-path';

export type ResendStatus = 'idle' | 'sending' | 'sent' | 'cooldown' | 'limitReached' | 'error';

type ResendErrorData = {
  error: string;
};

export const resendVerificationRequest = async (
  email: string,
  returnTo?: string,
): Promise<ResendStatus> => {
  const locale = getLocaleFromPathname(window.location.pathname);
  const response = await fetch('/api/auth/resend-verification', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, locale, ...(returnTo ? { returnTo } : {}) }),
  });
  if (response.ok) {
    return 'sent';
  }
  if (response.status === 429) {
    const data = (await response.json()) as ResendErrorData;
    if (data.error === 'cooldown') return 'cooldown';
    if (data.error === 'limitReached') return 'limitReached';
  }
  return 'error';
};
